import '.ci{width:100vw;}.ssr-plugin'
import '.az{min-height:100dvh;}.ssr-plugin'
import '.ap{position:relative;}.ssr-plugin'
import '.cj{height:124px;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.k{padding:24px;}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.am{justify-content:space-between;}.ssr-plugin'
import '.bx{display:grid;}.ssr-plugin'
import '.ck{grid-template-columns:1fr;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.cl{justify-items:center;}.ssr-plugin'
import '.aw{text-align:center;}.ssr-plugin'
import '.cm{grid-column:1;}.ssr-plugin'
import '.cn{grid-row:1;}.ssr-plugin'
import '.co{align-self:center;}.ssr-plugin'
import '.ar{pointer-events:none;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'
import { StepOne } from './StepOne.js'
import { StepTwo } from './StepTwo.js'
import { Logo } from '../../assets/svg/Logo.js'
import { Stepper } from '../../components/Stepper.js'
import { IconButton } from '../../components/IconButton.js'
import { Icon } from '../../assets/icons/index.js'
import { StepThree } from './StepThree.js'
import { StepFour } from './StepFour.js'
import { useTrack } from '../../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../../shared/analyticsEvents.js'
import { useSelectedVotingRegion } from '../../hooks/useSelectedVotingRegion.js'
import { MenuVotingRegion } from '../../components/MenuVotingRegion.js'
import { SelectLanguageModal } from '../../components/SelectLanguageModal.js'
import { SelectVotingRegionModal } from '../../components/SelectVotingRegionModal.js'
import {
  STEP_SLIDE_DURATION_MS,
  STEP_SLIDE_IN_LEFT,
  STEP_SLIDE_IN_RIGHT,
  STEP_SLIDE_OUT_LEFT,
  STEP_SLIDE_OUT_RIGHT,
} from '../../utils/animations.js'
import { MOBILE } from '../../utils/breakpoints.js'
import { PrivacyModal } from '../../components/PrivacyModal.js'
import { useDictionary } from '../../hooks/useDictionary.js'
import { useLanguage } from '../../hooks/useLanguage.js'
import { useVotingRegion } from '../../hooks/useVotingRegion.js'

const renderStep = (
  s: number,
  step: number,
  setStep: (n: number) => void,
  dictionary: any,
  setOpenLangSelectModal: any,
  setOpenRegionModal: any,
  setPrivacyModal: (x: boolean) => void,
) => {
  if (s === 0)
    return (
      <StepOne
        step={step}
        setStep={setStep}
        dictionary={dictionary}
        setOpenLangSelectModal={setOpenLangSelectModal}
        setOpenRegionModal={setOpenRegionModal}
      />
    )
  if (s === 1)
    return <StepTwo step={step} setStep={setStep} dictionary={dictionary} />
  if (s === 2)
    return <StepThree step={step} setStep={setStep} dictionary={dictionary} />
  if (s === 3)
    return (
      <StepFour dictionary={dictionary} setPrivacyModal={setPrivacyModal} />
    )
  return null
}

export const OnBoardingPage = () => {
  const [lang] = useLanguage()
  const [region] = useVotingRegion()
  const [step, setStep] = useState(0)
  const [prevStep, setPrevStep] = useState<number | null>(null)
  const [direction, setDirection] = useState<'forward' | 'backward'>('forward')
  const [privacyModal, setPrivacyModal] = useState(false)

  const track = useTrack('onboarding')
  const [selectedRegion] = useSelectedVotingRegion()

  const goToStep = (next: number) => {
    if (next === step) return
    setDirection(next > step ? 'forward' : 'backward')
    setPrevStep(step)
    setStep(next)
  }

  useEffect(() => {
    if (prevStep === null) return
    const t = setTimeout(() => setPrevStep(null), STEP_SLIDE_DURATION_MS)
    return () => clearTimeout(t)
  }, [prevStep, step])

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD, `${lang.code}-${region.code}`)
  }, [])

  const [openLangMenu, setOpenLangMenu] = useState(false)
  const [openLangSelectModal, setOpenLangSelectModal] = useState(false)
  const [openRegionModal, setOpenRegionModal] = useState(false)

  const dictionary = useDictionary()

  return (
    <>
      <div className="ci az ap"
      >
        <nav className="ap cj a k ag o am"
          id="onboarding-nav-content"
        >
          <IconButton
            ariaLabel="step-back"
            id="onboarding-nav-action-back-button"
            icon={<Icon type="backIcon" />}
            style={{
              opacity: step === 0 ? 0 : 1,
              pointerEvents: step === 0 ? 'none' : 'auto',
            }}
            onClick={() => goToStep(step - 1)}
          />
          <div>
            <Logo style={{ marginBottom: 48 }} width={95} height={32} />
            {selectedRegion !== 'SM' && (
              <Stepper currentStep={step + 1} steps={4} />
            )}
          </div>
          <IconButton
            ariaLabel="open-language-menu"
            id="onboarding-nav-action-menu-button"
            icon={<Icon type="globeIcon" style={{ pointerEvents: 'none' }} />}
            onClick={() => {
              setOpenLangMenu(!openLangMenu)
            }}
          />
        </nav>

        <div className="bx ck v cl a aw"
          key={selectedRegion}
        >
          {prevStep !== null && (
            <div className="cm cn co ar"
              key={`prev-${prevStep}`}
              style={{
                animation:
                  direction === 'forward'
                    ? STEP_SLIDE_OUT_LEFT
                    : STEP_SLIDE_OUT_RIGHT,
              }}
            >
              {renderStep(
                prevStep,
                prevStep,
                goToStep,
                dictionary,
                setOpenLangSelectModal,
                setOpenRegionModal,
                setPrivacyModal,
              )}
            </div>
          )}
          <div className="cm cn co"
            key={`cur-${step}`}
            style={{
              animation:
                direction === 'forward'
                  ? STEP_SLIDE_IN_RIGHT
                  : STEP_SLIDE_IN_LEFT,
            }}
          >
            {renderStep(
              step,
              step,
              goToStep,
              dictionary,
              setOpenLangSelectModal,
              setOpenRegionModal,
              setPrivacyModal,
            )}
          </div>
        </div>
      </div>
      {openLangMenu && (
        <MenuVotingRegion
          id="onboarding-nav-menu-modal"
          triggerId="onboarding-nav-action-menu-button"
          setOpen={setOpenLangMenu}
          setOpenLangSelectModal={setOpenLangSelectModal}
          setOpenRegionModal={setOpenRegionModal}
          style={{
            top: 72,
            right: 24,
            [MOBILE]: {
              top: '72px',
              left: '16px',
              right: '16px',
              maxWidth: 'unset',
              width: 'auto',
            },
          }}
        />
      )}

      {openLangSelectModal && (
        <SelectLanguageModal setModal={setOpenLangSelectModal} />
      )}

      {openRegionModal && (
        <SelectVotingRegionModal setModal={setOpenRegionModal} />
      )}

      {privacyModal && <PrivacyModal setModal={setPrivacyModal} />}
    </>
  )
}
